"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AxiosClient_1 = require("../../utils/AxiosClient");
var material_1 = require("@mui/material");
var AdminPanelSettingsRounded_1 = __importDefault(require("@mui/icons-material/AdminPanelSettingsRounded"));
var Person_1 = __importDefault(require("@mui/icons-material/Person"));
var ProfileComp = function () {
    var _a, _b;
    var _c = (0, react_1.useState)(null), sellerData = _c[0], setSellerData = _c[1];
    var userId = localStorage.getItem("userId");
    console.log("the userId", userId);
    console.log("/profile/".concat(userId));
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, AxiosClient_1.AxiosClient.get("/profile/".concat(userId))];
                    case 1:
                        response = _a.sent();
                        console.log("response", response);
                        if (response.data.statusCode === 200) {
                            setSellerData(response.data.data);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log("error", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [userId]);
    console.log("user data", sellerData);
    var role = localStorage.getItem("role");
    var renderAvatar = function () {
        if (role === "admin") {
            return (react_1.default.createElement(material_1.Avatar, { sx: {
                    bgcolor: "#1A120B",
                    color: "#fff",
                    width: "48px",
                    height: "48px",
                } },
                react_1.default.createElement(AdminPanelSettingsRounded_1.default, null)));
        }
        else {
            return (react_1.default.createElement(material_1.Avatar, { sx: {
                    bgcolor: "#1A120B",
                    color: "#fff",
                    width: "48px",
                    height: "48px",
                } },
                react_1.default.createElement(Person_1.default, null)));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#E5E5CB",
                width: "100%",
                height: "100vh",
                padding: "2rem",
                borderRadius: "10px",
                fontFamily: "Lato, sans-serif",
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#1A120B",
                    color: "#fff",
                    width: "120px",
                    height: "48px",
                    borderRadius: "4px",
                    mb: 1,
                } },
                react_1.default.createElement(material_1.Typography, { variant: "body1", sx: { mr: 1, textTransform: "capitalize" } }, role),
                role && renderAvatar()),
            sellerData ? (react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#FFFFFF",
                    padding: "2rem",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 8px rgba(27, 31, 35, 0.04)",
                } },
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Name:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } },
                        sellerData.firstName,
                        " ",
                        sellerData.lastName)),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Email:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, sellerData.email)),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Phone number:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, sellerData === null || sellerData === void 0 ? void 0 : sellerData.phoneNumber)),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Gender:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, sellerData === null || sellerData === void 0 ? void 0 : sellerData.gender)),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Birthdate:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, (sellerData === null || sellerData === void 0 ? void 0 : sellerData.birthdate)
                        ? sellerData.birthdate.split("T")[0]
                        : "")),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Language:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, sellerData.language)),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "City:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0 .5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, (_a = sellerData.billingAddress) === null || _a === void 0 ? void 0 : _a.city)),
                react_1.default.createElement("p", { style: {
                        marginBottom: "1rem",
                        color: "#586069",
                        fontWeight: "bold",
                    } },
                    "Country:",
                    react_1.default.createElement("span", { style: {
                            marginLeft: "0.5rem",
                            color: "#24292E",
                            fontWeight: "normal",
                        } }, (_b = sellerData.Address) === null || _b === void 0 ? void 0 : _b.country)),
                react_1.default.createElement(react_router_dom_1.Link, { to: "/edit-profile", style: {
                        marginTop: "1rem",
                        padding: "0.5rem 1rem",
                        backgroundColor: "#1B1F23",
                        color: "#FFFFFF",
                        borderRadius: "5px",
                        textDecoration: "none",
                        fontWeight: "bold",
                    } }, "Edit Profile"))) : (react_1.default.createElement("p", { style: { color: "#1A120B", textAlign: "center" } }, "loading profile data...")))));
};
exports.default = ProfileComp;
